// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hn","advertCardHeader__actions":"c-a_ho","advertCardHeader__bottomLabel":"c-a_hp"};